import { Inject, Injectable } from '@angular/core';
import { Config, WL_CONFIG } from './config';

@Injectable()
export class ConfigService {

    constructor(
        @Inject(WL_CONFIG) private readonly wlConfig: Config
    ) {
    }

    /**
     * Returns config settings for weblink app.
     */
    getConfig(): Config {
        return this.wlConfig;
    }
}